import React, {Component} from 'react';
import {Col, Form, FormGroup, ControlLabel} from "react-bootstrap";
import {TopInputDate} from "../../../../../../componentsTopsa/inputs/TopInputs";
import {TopSelect} from "../../../../../../componentsTopsa/selects/TopSelects";
import {TopButtonAction} from "../../../../../../componentsTopsa/buttons/TopButtons";
import TopDostepnosc from "../../../../../../componentsTopsa/dostepnosc/TopDostepnosc";
import moment from 'moment'
import DateAndTimeFormat from "../../../../../../utilities/DateAndTimeFormat";

export default class SprawdzKonfiguraceSearchbox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataOd: moment(),
            dataDo: moment(),
            trasa: null,
        };
        this.onChangeDataOd = this.onChangeDataOd.bind(this)
        this.onChangeDataDo = this.onChangeDataDo.bind(this)
        this.onChangeTrasa = this.onChangeTrasa.bind(this)
        this.onClickSzukaj = this.onClickSzukaj.bind(this)
    }

    componentDidMount() {
        this.setState({
            dataOd: moment(this.props.start),
            dataDo: moment(this.props.koniec)
        })
    }

    componentWillReceiveProps(nextprops) {
        this.setState({
            dataOd: moment(nextprops.start),
            dataDo: moment(nextprops.koniec)
        })
    }

    onChangeDataOd(e) {
        this.setState({dataOd: e})
    }

    onChangeDataDo(e) {
        this.setState({dataDo: e})
    }

    onChangeTrasa(e) {
        this.setState({trasa: e})
    }

    onClickSzukaj() {
        if (Boolean(this.state.dataOd) && Boolean(this.state.dataDo)) {
            let params = {
                dataOd: DateAndTimeFormat.formatYYYYMMDD(this.state.dataOd),
                dataDo: DateAndTimeFormat.formatYYYYMMDD(this.state.dataDo),
                idTr: Boolean(this.state.trasa) ? this.state.trasa.idTr : null,
            }
            this.props.handleClickSzukaj(params)
        } else {
            alert('Należy uzupełnić daty od i do')
        }
    }

    formatTrasaSelect(option) {
        return <div><span className={'label label-ebus-primary'}>{option.kodTrasy}</span> {option.nazTr} <TopDostepnosc wartoscWarunek={0}
                                                                                                                          wartosc={option.status}
                                                                                                                          czyMarginesLewy={true}/>
        </div>
    }

    render() {

        return (
            <div>
                <Form>
                    <FormGroup>
                        <Col xs={12} lg={2}>
                            <ControlLabel>
                                Data od <span style={{color: 'red'}}>*</span>
                            </ControlLabel>
                            <TopInputDate onChange={this.onChangeDataOd} value={this.state.dataOd}/>
                        </Col>
                        <Col xs={12} lg={2}>
                            <ControlLabel>
                                Data do <span style={{color: 'red'}}>*</span>
                            </ControlLabel>
                            <TopInputDate onChange={this.onChangeDataDo} value={this.state.dataDo}/>
                        </Col>

                        {
                            Boolean(this.props.ukryjTrasy) ?
                                ''
                                :
                                <Col xs={12} lg={3}>
                                    <ControlLabel>
                                        Trasa
                                    </ControlLabel>
                                    <TopSelect onChange={this.onChangeTrasa}
                                               value={this.state.trasa}
                                               options={this.props.trasy}
                                               valueKey={'idTr'}
                                               labelKey={'nazTr'}
                                               valueRenderer={this.formatTrasaSelect}
                                               optionRenderer={this.formatTrasaSelect}
                                               clearable={true}
                                    />
                                </Col>
                        }
                        <Col xs={12} lg={3}>
                            <div className={'add-label-margin'}></div>
                            <TopButtonAction text={'Szukaj'} iconType={'fa fa-search'} btnSize={'medium'} onClick={this.onClickSzukaj}/>
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/sprawdzKonfiguracje/components/componentsRozklad/SprawdzKonfiguraceSearchbox.js